import { render, staticRenderFns } from "./FireRiskSettings.page.vue?vue&type=template&id=1a473ebc"
import script from "./FireRiskSettings.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./FireRiskSettings.page.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports